import analyticsEmbed from './analytics-embed';
import auditor from './auditor';
import course from './course';
import purchaser from './purchaser';
import signInQrExportJobStatus from './sign-in-qr-export-job-status';
import student from './student';
import teacher from './teacher';
import user from './user';

export default {
  'analytics-embed': analyticsEmbed,
  auditor,
  course,
  purchaser,
  'sign-in-qr-export-job-status': signInQrExportJobStatus,
  student,
  teacher,
  user,
};
